export const supportedColors = [
  "tomato",
  "red",
  "crimson",
  "pink",
  "plum",
  "purple",
  "violet",
  "indigo",
  "blue",
  "cyan",
  "teal",
  "green",
  "grass",
  "orange",
  "brown",
  "sky",
  "mint",
  "lime",
  "yellow",
  "amber",
  "gold",
  "bronze",
  "gray",
  "mauve",
  "slate",
  "sage",
  "olive",
  "sand",
] as const;

export type Color = (typeof supportedColors)[number];

export type ColorVariant =
  | "solid"
  | "outline"
  | "light"
  | "lightOutline"
  | "solidMono"
  | "ghost"
  | "pastel";

export type InputAppearance = "outline" | "filled" | "filled-outline";
export type BorderRadius = "none" | "sm" | "md" | "lg" | "full";
export type Appearance = "light" | "dark";

export type ButtonSize = "xs" | "sm" | "md" | "lg" | "xl";
export type ButtonAppearance = "primary" | "secondary" | "minimal";

export type ButtonAppearanceSchemaType = Partial<
  Record<ButtonAppearance, { variant: ColorVariant; color: Color }>
>;
export type DisplayType =
  | "block"
  | "inline"
  | "inline-block"
  | "flex"
  | "none"
  | "grid"
  | "inline-flex";

export type PositionType = "absolute" | "relative" | "fixed" | "sticky";

export type JustifyContentType =
  | "start"
  | "center"
  | "end"
  | "space-between"
  | "space-around"
  | "space-evenly";

export type AlignItemsType =
  | "start"
  | "center"
  | "end"
  | "stretch"
  | "baseline";

export type FlexDirectionType =
  | "row"
  | "column"
  | "row-reverse"
  | "column-reverse";

export type SizeOption =
  | "none"
  | "4xs"
  | "3xs"
  | "2xs"
  | "xs"
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl";

export const borderRadiusShapeMap = {
  sharp: "none",
  pill: "full",
  rounded: undefined,
};
